import Vue from 'vue';
import vuescroll from 'vuescroll/dist/vuescroll-native';
import button from './template/button.vue';
import selectField from './template/fields/select.vue';
import ckeditor from "./template/fields/ckeditor.vue";
import scriptInput from "./template/fields/script.vue";
import numberInput from './template/fields/numberInput';
import dateTimeInput from './template/fields/dateTimeInput';
import link from './template/fields/link.vue';
import textarea from './template/fields/textarea.vue';
import richText from './template/fields/richText.vue';
import timeInput from './template/fields/time/timeInput';
import checkbox from './template/checkbox/checkbox';
import dropDownMenu from './template/dropDownMenu/dropDownMenu.vue';
import radio from './template/radio/radio';
import arrowDown from './template/img/arrowDown';
import chooseImg from './template/img/chooseImg';
import editImg from './template/img/editImg';
import fork from './template/img/fork';
import tick from './template/img/tick';
import clock from './template/img/time';
import maxBox from './template/img/maxBox';
import restoreBox from './template/img/restoreBox';
import linkImg from './template/img/link';
import generalGroup from './template/img/generalGroup';
import exportImg from './template/img/export';
import importImg from './template/img/import';
import clearImg from './template/img/clear';
import searchImg from './template/img/search';
import refreshImg from './template/img/refresh';
import yearField from './template/fields/year/yearInput.vue';
import textField from "./template/fields/textInput.vue";
import passwordField from "./template/passwordInput.vue";
import dateField from "./template/fields/date/dateInput.vue";
import chooseField from './template/fields/chooseInput.vue';
import comboBoxField from './template/fields/comboBox/comboBox.vue';
import cronField from './template/fields/cron/cronInput.vue';
import formulaField from './template/fields/formula/formula';
import simpleCheckbox from './template/fields/simpleCheckbox';
import imageField from './template/fields/image';
import signField from './template/fields/sign';
import checkboxField from './template/fields/checkbox';
import more from './template/img/more';
import fileImg from './template/img/file';
import roundAddImg from './template/img/roundAdd.vue';
import roundMinusImg from './template/img/roundMinus.vue';
import gouImg from './template/img/gouImg.vue';
import lastPageImg from './template/img/lastPage.vue';
import nextPageImg from './template/img/nextPage.vue';
import closeNodeImg from './template/img/closeNode';
import openNodeImg from './template/img/openNode';
import timeLeftImg from './template/img/timeLeft.vue'
import timeRightImg from './template/img/timeRight.vue'
import homeImg from './template/img/homeImg';
import menuSwitchImg from './template/img/menuSwitchImg';
import showPasswordImg from './template/img/showPassword';
import hidePasswordImg from './template/img/hidePassword';
import shortcutMeunImg from './template/img/shortcutMeun';
import menuSwitchShortcutImg from './template/img/menuSwitchShortcut';
import userImg from './template/img/user';
import configImg from './template/img/configImg';
import dragImg from './template/img/dragImg';
import platformImg from './template/img/platform';


export default {
    install() {
        this.installImage();
        this.installFieldEditor();
        this.installCommonComp();
        this.installVueScroll();
    },

    /**
     * 注册图标，统一使用Img结尾
     */
    installImage() {
        Vue.component('arrowDown', arrowDown);
        Vue.component('fork', fork);
        Vue.component('tick', tick);
        Vue.component('maxBox', maxBox);
        Vue.component('restoreBox', restoreBox);
        Vue.component('clock', clock);
        Vue.component('linkImg', linkImg);
        Vue.component('chooseImg', chooseImg);
        Vue.component('editImg', editImg);
        Vue.component('moreImg', more);
        Vue.component('generalGroup', generalGroup);
        Vue.component('userImg', userImg);
        Vue.component('exportImg', exportImg);
        Vue.component('importImg', importImg);
        Vue.component('clearImg', clearImg);
        Vue.component('searchImg', searchImg);
        Vue.component('refreshImg', refreshImg);
        Vue.component('roundAddImg', roundAddImg);
        Vue.component('roundMinusImg', roundMinusImg);
        Vue.component('gouImg', gouImg);
        Vue.component('lastPageImg', lastPageImg);
        Vue.component('nextPageImg', nextPageImg);
        Vue.component('fileImg', fileImg);
        Vue.component('closeNodeImg', closeNodeImg);
        Vue.component('openNodeImg', openNodeImg);
        Vue.component('timeLeftImg', timeLeftImg);
        Vue.component('timeRightImg', timeRightImg);
        Vue.component('homeImg', homeImg);
        Vue.component('menuSwitchImg', menuSwitchImg);
        Vue.component('shortcutMeunImg', shortcutMeunImg);
        Vue.component('menuSwitchShortcutImg', menuSwitchShortcutImg);
        Vue.component('showPasswordImg', showPasswordImg);
        Vue.component('hidePasswordImg', hidePasswordImg);
        Vue.component('configImg', configImg);
        Vue.component('dragImg', dragImg);
        Vue.component('platformImg', platformImg);
    },

    /**
     * 注册字段属性，统一使用Field结尾
     */
    installFieldEditor() {
        Vue.component('ckeditorField', ckeditor);
        Vue.component('scriptField', scriptInput);
        Vue.component('numberField', numberInput);
        Vue.component('yearField', yearField);
        Vue.component('timeField', timeInput);
        Vue.component('linkField', link);
        Vue.component('textField', textField);
        Vue.component('passwordField', passwordField);
        Vue.component('dateField', dateField);
        Vue.component('textareaField', textarea);
        Vue.component('richTextField', richText);
        Vue.component('selectField', selectField);
        Vue.component('chooseField', chooseField);
        Vue.component('comboBoxField', comboBoxField);
        Vue.component('cronField', cronField);
        Vue.component('dateTimeField', dateTimeInput);
        Vue.component('simpleCheckboxField', simpleCheckbox);
        Vue.component('imageField', imageField);
        Vue.component('signField', signField);
        Vue.component('checkboxField', checkboxField);
        Vue.component('formulaField', formulaField);
    },

    /**
     * 注册通用组件
     */
    installCommonComp() {
        Vue.component('gbutton', button);
        Vue.component('combo-box', selectField);
        Vue.component('checkbox', checkbox);
        Vue.component('radio', radio);
        Vue.component('dropDownMenu', dropDownMenu);
    },

    /**
     * 注册滚动条组件
     */
    installVueScroll() {
        Vue.use(vuescroll, {
            ops: {
                bar: {
                    background: '#bbb',
                    size: '8px',
                    onlyShowBarOnScroll: false
                },
                detectResize: true,

            },
            name: 'scroll'
        });
    }
}